import { observer } from 'mobx-react';
import * as React from 'react';
import GroupSearchFilters from './Groups/GroupSearchFilters';
import GroupsTable from './Groups/GroupsTable';
import PeopleSearchFilters from './People/PeopleSearchFilters';
import PeopleTable from './People/PeopleTable';
import { participantSearchStore } from './Stores/ParticipantSearchStore';

const Tabs: React.FC = () => {
  return (
    <div className="px-8 pt-6" data-intercom-target="participant-search-results">
      {participantSearchStore.activeTab === 'participants' ? (
        <>
          <PeopleSearchFilters />
          <PeopleTable />
        </>
      ) : (
        <>
          <GroupSearchFilters />
          <GroupsTable />
        </>
      )}
    </div>
  );
};

export default observer(Tabs);
